export const PUBLIC_SEO_TITLE = 'Apropos.jobs - Hiring starts with clarity'

export const PUBLIC_SEO_DESCRIPTION =
	'Apropos.jobs helps companies define job-roles clearly and align candidates based on working styles and expectations beyond CVs and guesswork before decisions are made.'
